<template>
  <!--====================  header area ====================-->
  <div class="header-area">
    <div class="header-area__desktop header-area__desktop--default">
      <div class="header-top-bar green-bg">
        <div class="container">
          <div class="row align-items-center p-md-3">
            <div class="col-lg-3">
              <!-- top bar left -->
              <div class="top-bar-left-wrapper">
                <p class="text-white">
                  <span><i class="fa fa-envelope mr-2"></i></span
                  >{{ meta.email }}
                </p>
              </div>
            </div>
            <div class="col-lg-2">
              <!-- top bar left -->
              <div class="top-bar-left-wrapper">
                <p class="text-white">
                  <span><i class="fa fa-phone mr-2"></i></span>{{ meta.phone }}
                </p>
              </div>
            </div>
            <div class="col-lg-7">
              <!-- top bar right -->
              <div class="top-bar-right-wrapper">
                <div
                  class="social-links social-links--white-topbar d-inline-block"
                >
                  <ul>
                    <li>
                      <a href="#" target="_blank">ikuti kami</a>
                    </li>
                    <li>
                      <a :href="contact.facebook.body" target="_blank"
                        ><i class="font-size-20 fa fa-facebook-square"></i
                      ></a>
                    </li>
                    <li>
                      <a :href="contact.twitter.body" target="_blank"
                        ><i class="font-size-20 fa fa-twitter"></i
                      ></a>
                    </li>
                    <li>
                      <a :href="contact.instagram.body" target="_blank"
                        ><i class="font-size-20 fa fa-instagram"></i
                      ></a>
                    </li>
                    <li>
                      <a :href="contact.linkedin.body" target="_blank"
                        ><i class="font-size-20 fa fa-linkedin"></i
                      ></a>
                    </li>
                    <li>
                      <a :href="contact.youtube.body" target="_blank"
                        ><i class="font-size-20 fa fa-youtube"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-info-area">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="header-info-wrapper align-items-center">
                <div
                  class="mobile-navigation-icon"
                  id="mobile-menu-trigger"
                  @click="mobiletoggleClass('addClass', 'active')"
                >
                  <i></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <fixed-header>
        <div class="header-navigation-area bg-white">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-4">
                <a class="navbar-brand font-weight-bold" href="/">
                  {{ meta.name }}
                </a>
              </div>
              <div class="col-lg-8">
                <div
                  class="header-navigation header-navigation--header-default position-relative"
                >
                  <div class="header-navigation__nav position-static">
                    <nav>
                      <ul>
                        <li>
                          <router-link :to="`/${meta.preview}`"
                            >Home</router-link
                          >
                        </li>
                        <li
                          class="has-children has-children--multilevel-submenu"
                        >
                          <a>Profil</a>
                          <ul class="submenu">
                            <li>
                              <router-link :to="`/visi-misi${meta.preview}`"
                                >Visi Misi</router-link
                              >
                            </li>
                            <li>
                              <router-link :to="`/tujuan${meta.preview}`"
                                >Tujuan</router-link
                              >
                            </li>
                            <li>
                              <router-link :to="`/sejarah${meta.preview}`"
                                >Sejarah</router-link
                              >
                            </li>
                            <!-- <li>
                              <router-link :to="`/sambutan${meta.preview}`"
                                >Sambutan</router-link
                              >
                            </li> -->
                            <li>
                              <router-link :to="`/jajaran${meta.preview}`"
                                >Jajaran</router-link
                              >
                            </li>
                          </ul>
                        </li>
                        <li
                          class="has-children has-children--multilevel-submenu"
                        >
                          <a>Kewirausahaan</a>
                          <ul class="submenu">
                            <li>
                              <router-link :to="`/kewirausahaan${meta.preview}`"
                                >Vokasi Istimewa</router-link
                              >
                            </li>
                            <li v-if="$store.state.token">
                              <router-link :to="`/toko-saya${meta.preview}`"
                                >Toko Saya</router-link
                              >
                            </li>
                          </ul>
                        </li>
                        <li
                          class="has-children has-children--multilevel-submenu"
                        >
                          <a>Informasi</a>
                          <ul class="submenu">
                            <li>
                              <router-link :to="`/pengumuman${meta.preview}`"
                                >Pengumuman</router-link
                              >
                            </li>
                            <li>
                              <router-link :to="`/galeri${meta.preview}`"
                                >Galeri</router-link
                              >
                            </li>
                            <li>
                              <router-link :to="`/berita${meta.preview}`"
                                >Berita</router-link
                              >
                            </li>
                            <!-- <li>
                                                  <router-link :to="`/buku-tamu">Buku Tamu</router-link>
                                                </li> -->
                          </ul>
                        </li>
                        <li>
                          <router-link :to="`/jurusan${meta.preview}`"
                            >Jurusan</router-link
                          >
                        </li>
                        <li>
                          <router-link :to="`/ekstra-kurikuler${meta.preview}`"
                            >Ekstrakurikuler</router-link
                          >
                        </li>
                        <li>
                          <router-link :to="`/postingan${meta.preview}`"
                            >Postingan</router-link
                          >
                        </li>
                        <li>
                          <a :href="urlPPDB" target="_blank">PPDB</a>
                        </li>
                        <li>
                          <router-link :to="`/kontak${meta.preview}`"
                            >Kontak</router-link
                          >
                        </li>
                        <li
                          v-if="$store.state.token"
                          class="has-children has-children--multilevel-submenu"
                        >
                          <a>Hi !</a>
                          <ul class="submenu">
                            <li>
                              <a href="javascript:void(0)" @click="dataLogout()"
                                >Logout</a
                              >
                            </li>
                          </ul>
                        </li>
                        <li v-else>
                          <router-link :to="`/login${meta.preview}`"
                            >Login</router-link
                          >
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fixed-header>
      <!--=======  End of header navigation area =======-->
    </div>
  </div>
  <!--====================  End of header area  ====================-->
</template>
<script>
import broker from "../utils/broker";
import FixedHeader from "vue-fixed-header";
export default {
  props: ["meta"],
  data: () => {
    return {
      urlPPDB: process.env.VUE_APP_PPDB_ENDPOINT,
      modalName: "modalLogin",
      contact: {
        facebook: {},
        twitter: {},
        instagram: {},
        linkedin: {},
        youtube: {},
      },
    };
  },
  components: {
    FixedHeader,
  },
  mounted() {
    broker.fetch
      .get(
        `/webschool/content?types[]=social_youtube&types[]=social_facebook&types[]=social_instagram&types[]=social_twitter&types[]=social_linkedin&status=published`
      )
      .then((res) => {
        const data = res.data.data;
        this.contact.facebook = data.find(
          (o) => o.type.name === "social_facebook"
        );
        this.contact.instagram = data.find(
          (o) => o.type.name === "social_instagram"
        );
        this.contact.twitter = data.find(
          (o) => o.type.name === "social_twitter"
        );
        this.contact.linkedin = data.find(
          (o) => o.type.name === "social_linkedin"
        );
        this.contact.youtube = data.find(
          (o) => o.type.name === "social_youtube"
        );
      });
  },
  methods: {
    // offcanvas mobilemenu
    mobiletoggleClass(addRemoveClass, className) {
      const el = document.querySelector("#offcanvas-menu");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    async dataLogout() {
      this.$store.dispatch("updateUser", {});
      this.$store.dispatch("updateUserToken", "");
      this.$Toast.fire({
        type: "success",
        title: "Berhasil Logout",
      });
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
.vue-fixed-header--isFixed {
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 999;
  position: fixed;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
  animation: 900ms cubic-bezier(0.2, 1, 0.22, 1) 0s normal none 1 running
    fadeInDown;
}

.navbar-brand {
  white-space: inherit !important;
  font-size: 1.1rem !important;
}
</style>
